import { TemplatePreset, PresetCategory } from '../../store/types/template';
import { Industry, UseCase } from '../../types/onboarding';

export const ALL_CATEGORY = 'All';

export const PRESET_CATEGORIES: PresetCategory[] = [
  'Events',
  'Sports & fitness',
  'Hospitality',
  'Retail',
  'Travel & Transit',
  'Workplace & education',
  'Insurance',
];

export type GalleryCategory = PresetCategory | typeof ALL_CATEGORY;

export const RECOMMENDED_PRESETS_CAP = 3;

const INDUSTRY_CATEGORY: Partial<Record<Industry, PresetCategory>> = {
  sport: 'Sports & fitness',
  hospitality: 'Hospitality',
  retail: 'Retail',
  events_entertainment: 'Events',
  tourism_attractions: 'Travel & Transit',
  transport_aviation: 'Travel & Transit',
  food_beverage: 'Hospitality',
};

export const getRecommendedPresetIds = (
  presets: TemplatePreset[],
  orgUseCases: UseCase[] | null | undefined,
  orgIndustry?: Industry | null
): Set<string> => {
  const ids = new Set<string>();
  if (!orgUseCases?.length) return ids;
  const industryCategory = orgIndustry
    ? INDUSTRY_CATEGORY[orgIndustry]
    : undefined;
  const matchesIndustry = (preset: TemplatePreset) =>
    !!industryCategory && preset.metadata.categories.includes(industryCategory);
  const pools = orgUseCases.map((useCase) => {
    const pool = presets.filter((preset) =>
      preset.metadata.useCases.includes(useCase)
    );
    return [...pool].sort(
      (a, b) => Number(matchesIndustry(b)) - Number(matchesIndustry(a))
    );
  });
  let added = true;
  while (ids.size < RECOMMENDED_PRESETS_CAP && added) {
    added = false;
    for (const pool of pools) {
      if (ids.size >= RECOMMENDED_PRESETS_CAP) break;
      const next = pool.find((preset) => !ids.has(preset.metadata.id));
      if (next) {
        ids.add(next.metadata.id);
        added = true;
      }
    }
  }
  return ids;
};

export const filterPresetsByCategory = (
  presets: TemplatePreset[],
  category: GalleryCategory
): TemplatePreset[] =>
  category === ALL_CATEGORY
    ? presets
    : presets.filter((preset) => preset.metadata.categories.includes(category));

export const sortRecommendedFirst = (
  presets: TemplatePreset[],
  recommendedIds: ReadonlySet<string>
): TemplatePreset[] =>
  [...presets].sort(
    (a, b) =>
      Number(recommendedIds.has(b.metadata.id)) -
      Number(recommendedIds.has(a.metadata.id))
  );
